import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { view, lensProp, lensPath } from 'ramda'
import PropTypes from 'prop-types'
import NotificationMediaPropTypes from './NotificationMediaPropTypes'
import PDFMediaSection from 'app/components/PDFMediaSection'
import { TYPE_VOUCHER } from 'app/constants/messageType'
import clsx from 'clsx'
import * as R from 'ramda'

const useStyles = makeStyles({
  previewStyle: {
    borderRadius: 0,
  },
  notificationImage: {
    minWidth: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  imageMask: {
    position: 'absolute',
    backgroundImage:
      'linear-gradient(to top, #000000 1%, rgba(84, 84, 84, 0.27) 60%)',
    opacity: '0.27',
    width: '100%',
    height: '99%',
  },
  imageText: {
    position: 'absolute',
    bottom: '8px',
    right: '16px',
    color: 'ghostwhite',
  },
})

const getYoutubeIdFromUrl = (url) => {
  if (url.includes('youtu.be')) {
    //shorten type > 'https://youtu.be/eAxlrUf05ok/'
    return url.split('/')[3]
  }
  var videoId = url.split('v=')[1]
  var ampersandPosition = videoId.indexOf('&')
  if (ampersandPosition !== -1) {
    videoId = videoId.substring(0, ampersandPosition)
  }
  return videoId
}
const isShowImageNumber = (media) => media && media.content.length > 1
const getYoutubeEmbededUrl = (url) =>
  `https://www.youtube.com/embed/${getYoutubeIdFromUrl(url)}`

const NotificationMediaPreview = ({ media, type = undefined }) => {
  const classes = useStyles()
  switch (view(lensProp('type'), media)) {
    case 'image': {
      if (R.isNil(view(lensPath(['content', 'url']), media))) {
        return null
      }

      return R.path(['content', 'url'], media) ? (
        <div className="relative justify-center items-center h-full ">
          {isShowImageNumber(media) ? (
            <div
              className={clsx(classes.imageMask, classes.notificationImage)}
            ></div>
          ) : null}
          <img
            src={media.content.url}
            className={clsx({
              'px-5': [TYPE_VOUCHER].includes(type),
              [classes.notificationImage]: ![TYPE_VOUCHER].includes(type),
            })}
            alt="Notification media images"
          />
          {isShowImageNumber(media) ? (
            <div className={clsx(classes.imageText, 'text-28')}>
              {`+${media.content.length - 1}`}
            </div>
          ) : null}
        </div>
      ) : null
    }
    case 'video': {
      if (R.isNil(view(lensPath(['content', 'url']), media))) {
        return null
      }

      return (
        <div>
          <iframe
            style={{
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
            title="video"
            src={getYoutubeEmbededUrl(media.content.url)}
          />
        </div>
      )
    }
    case 'pdf': {
      if (R.isNil(view(lensPath(['content', 'fileName']), media))) {
        return null
      }

      return (
        <PDFMediaSection
          fileName={view(lensPath(['content', 'fileName']), media)}
          fileSize={view(lensPath(['content', 'fileSize']), media)}
          onClick={() => {}}
        ></PDFMediaSection>
      )
    }
    default: {
      return null
    }
  }
}

NotificationMediaPreview.propTypes = {
  media: PropTypes.oneOfType([
    PropTypes.shape(NotificationMediaPropTypes),
    PropTypes.bool,
  ]),
}

export default NotificationMediaPreview
